export const DndComplaintActionType = {
    DND_COMPLAINT_SUBMISSION_LOADING: 'DND_COMPLAINT_SUBMISSION_LOADING',
    DND_COMPLAINT_SUBMISSION_SUCCESS: 'DND_COMPLAINT_SUBMISSION_SUCCESS',
    DND_COMPLAINT_SUBMISSION_ERROR: 'DND_COMPLAINT_SUBMISSION_ERROR'
}